<template>
  <v-card flat>
    <v-card-title>
      {{ $t("carte.title") }}
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="ligneHeaders"
        :items="cartes"
        item-key="id"
        :item-class="itemRowClass"
        :search="search"
        clearable
        @dblclick:row="openDialog"
      >
        <template #top="">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Rechercher"
            single-line
            hide-details
            clearable
            class="mb-4"
          />
        </template>
        <template #[`item.structure`]="{ item }">
          {{ getSt(item.structure) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("carte.link") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-checkbox v-model="isActive" :label="$t('carte.isActive')" />
            <v-autocomplete
              v-model="struct"
              :items="structs"
              item-value="id"
              chips
              deletable-chips
              item-text="libelle"
              :label="$t('carte.structure')"
              :rules="[validrules.requiredSelect(struct)]"
            />
            <v-autocomplete
              v-model="gestionnaires"
              :label="$t('carte.gestionnaires')"
              :items="filteredUsers()"
              item-value="id"
              item-text="name"
              multiple
              chips
              deletable-chips
              clearable
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="color_danger" @click="dialog = false">
            <v-icon left dark> mdi-close</v-icon>
            {{ $t("btn.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="
              !valid ||
              struct === null ||
              gestionnaires === null ||
              struct === undefined ||
              gestionnaires === undefined
            "
            color="color_action"
            @click="closeDialog"
          >
            <v-icon left dark> mdi-send</v-icon>
            {{ $t("btn.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { carteMixin } from "@/mixins/carte";
import { structureMixin } from "@/mixins/structure";
import { drMixin } from "@/mixins/dr";
import { userMixin } from "@/mixins/user";
import { validrules } from "@/common/validrules";

export default {
  name: "VueLinkCarte",
  mixins: [carteMixin, structureMixin, drMixin, userMixin],
  data() {
    return {
      dialog: false,
      struct: null,
      gestionnaires: null,
      search: "",
      isActive: null,
      carte: null,
      valid: false,
      validrules: validrules,
    };
  },
  computed: {
    ligneHeaders() {
      return [
        {
          text: this.$t("carte.sb"),
          align: "start",
          sortable: true,
          value: "structure",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.nom"),
          align: "start",
          sortable: true,
          value: "nom",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.prenom"),
          align: "start",
          sortable: true,
          value: "prenom",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.num"),
          align: "start",
          sortable: true,
          value: "num",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.date"),
          align: "start",
          sortable: true,
          value: "date",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.gestionnaires"),
          align: "start",
          sortable: true,
          value: "gestions",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("carte.centre_facturation"),
          align: "start",
          sortable: true,
          value: "centre_facturation",
          class: "color_thead  lighten-2 white--text",
        },
      ];
    },
  },
  mounted() {
    this.getStructs();
    this.getDrs();
    this.getCartes();
    this.getUsers();
  },
  methods: {
    itemRowClass: function (item) {
      return !item.is_active ? "grey--text text--lighten-1" : "";
    },
    searchStruct(item) {
      return this.structs.find(function (s) {
        return s.id === item;
      });
    },
    getSt(item) {
      const s = this.searchStruct(item);
      if (s !== undefined) return s.libelle;
    },
    openDialog(event, { item }) {
      this.dialog = true;
      this.carte = item;
      this.struct = item.structure;
      this.gestionnaires = item.gestionnaires;
      this.isActive = item.is_active;
    },
    closeDialog() {
      this.updateCarte({
        id: this.carte.id,
        values: {
          structure: this.struct,
          is_active: this.isActive,
          gestionnaires: this.gestionnaires ? this.gestionnaires : [],
        },
      });
      this.carte.structure = this.struct;
      this.carte.is_active = this.isActive;
      this.dialog = false;
      this.userRetrieve();
    },
    filteredUsers() {
      const s = this.struct;
      const struct = this.structs.find((x) => x.id === s);
      return struct
        ? this.users.filter((x) => x.name.includes(struct.libelle))
        : null;
    },
  },
};
</script>
